
import { Component, Mixins, Watch } from "vue-property-decorator";
import { WebStorageAccessor } from "../../../store/WebStorageAccessor";
import { WebStorageKeys } from "../../../store/WebStorageKeys";

@Component({
})
export default class DeveloperPresentableMixin extends Mixins() {
  data(): any {
    return {
      isDeveloperMode: WebStorageAccessor.isDeveloperMode,
    };
  }
  isDeveloperMode: boolean;

  mounted(): void {
    WebStorageAccessor.addUpdateEventListener(WebStorageKeys.isDeveloperMode, (e: StorageEvent) => {
      const isDeveloperMode = (e.newValue.toLowerCase() === true.toString().toLowerCase());
      if (this.isDeveloperMode !== isDeveloperMode) {
        this.isDeveloperMode = isDeveloperMode;
      }
    });
  }

  @Watch("isDeveloperMode")
  onDeveloperPresentableDeveloperModeUpdated(newValue: boolean, oldValue: boolean): void {
    if (WebStorageAccessor.isDeveloperMode !== newValue) {
      WebStorageAccessor.isDeveloperMode = newValue;
    }
  }
}
